import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ToolBarProps from './ToolBarProps'
import KendoToolBarItem from './KendoToolBarItem'

export default {
    template: '<div><slot></slot></div>',
    props: ToolBarProps,
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoToolBar(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoToolBar()
        },
        _resolveChildren() {
            this.resolveChildren('items', KendoToolBarItem.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/KendoToolBarMixin.js